import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { requestPaymentApi } from "../../lib/api";

export const PaymentCallbackPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reference = searchParams.get("reference") || searchParams.get("trxref");
  const [isVerifying, setIsVerifying] = useState(true);

  const encodedToken = encodeURIComponent(token || "");
  const successUrl = `/pay/${encodedToken}/success`;
  const failureUrl = `/pay/${encodedToken}/failure`;

  useEffect(() => {
    const routeToFailure = (message) => {
      //   navigate(`${failureUrl}?message=${encodeURIComponent(message)}`, {
      //     replace: true,
      //   });
      navigate(`${failureUrl}`, {
        replace: true,
      });
    };

    if (!reference) {
      routeToFailure("Something went wrong. Please go back and try again.");
      return;
    }

    const controller = new AbortController();

    const verifyPayment = async () => {
      try {
        const { data } = await requestPaymentApi(
          `/api/pay/${encodeURIComponent(token)}/verify?reference=${encodeURIComponent(reference)}`,
          {
            signal: controller.signal,
          },
        );

        if (data.status === true) {
          //   const amountQuery = encodeURIComponent(data.amount ?? "");
          //   const messageQuery = encodeURIComponent(data.message || "Payment successful");
          //   navigate(
          //     `${successUrl}?amount=${amountQuery}&message=${messageQuery}`,
          //     { replace: true },
          //   );
          navigate(`${successUrl}`, { replace: true });
          return;
        }

        routeToFailure(
          data.message ||
            "Payment verification failed or payment was not successful",
        );
      } catch (error) {
        if (error.name !== "AbortError") {
          routeToFailure("Check your connection and try again.");
        }
      } finally {
        setIsVerifying(false);
      }
    };

    verifyPayment();

    return () => controller.abort();
  }, [failureUrl, navigate, reference, successUrl, token]);

  return (
    <div className="min-h-screen bg-grey-50 satoshi text-grey-900">
      <header className="flex h-16 items-center justify-between border-b border-grey-200 bg-white px-4 sm:h-[76px] sm:px-8 lg:px-[72px]">
        <a href="/" aria-label="MyCardGlobal home">
          <img
            className="h-auto max-h-[42px] w-24 object-contain sm:w-28"
            src="/logo.svg"
            alt="MyCardGlobal"
          />
        </a>
        <span className="inline-flex items-center gap-2 text-xs font-medium text-grey-600 sm:text-[13px]">
          <span
            className="h-2 w-2 rounded-full bg-green shadow-[0_0_0_3px_rgba(65,147,94,0.12)]"
            aria-hidden="true"
          />
          Secure payment
        </span>
      </header>

      <main className="mx-auto w-[calc(100%-2rem)] max-w-[520px] py-10 sm:py-16">
        <section className="rounded-2xl border border-grey-200 bg-white p-6 text-center shadow-sm sm:p-8">
          {isVerifying && (
            <>
              <span
                className="mx-auto mb-4 block h-9 w-9 animate-spin rounded-full border-2 border-grey-200 border-t-primary motion-reduce:animate-none"
                aria-hidden="true"
              />
              <h1 className="text-[28px] font-bold leading-[32px] tracking-[-0.02em] text-deep-primary sm:text-[34px] sm:leading-[38px]">
                Verifying your payment...
              </h1>
              <p className="mt-3 text-sm text-grey-600 sm:text-base">
                This may take a few seconds. Please keep this page open.
              </p>
            </>
          )}
        </section>
      </main>
    </div>
  );
};
